export const calculationTypeYxy = 'Yxy';
export const calculationTypeCct = 'cct';

export const calculationType = [calculationTypeYxy, calculationTypeCct] as const;
export type CalculationType = typeof calculationType[number];
